export const BUTTON_TYPES = {
  primary: {
    default: {
      borderColor: ['greyscale', 'black'],
      color: ['greyscale', 'white'],
      background: ['greyscale', 'black'],
    },
    hover: {
      borderColor: ['greyscale', 'black'],
      color: ['greyscale', 'white'],
      background: ['greyscale', 'medium'],
    },
  },
  cta: {
    default: {
      borderColor: ['greyscale', 'black'],
      color: ['greyscale', 'white'],
      background: ['greyscale', 'black'],
    },
    hover: {
      borderColor: ['greyscale', 'black'],
      color: ['greyscale', 'white'],
      background: ['greyscale', 'dark'],
    },
  },
  secondary: {
    default: {
      borderColor: ['greyscale', 'medium'],
      color: ['greyscale', 'black'],
      background: ['greyscale', 'white'],
    },
    hover: {
      borderColor: ['greyscale', 'black'],
      color: ['greyscale', 'black'],
      background: ['greyscale', 'light'],
    },
  },
  danger: {
    default: {
      borderColor: ['greyscale', 'medium'],
      color: ['danger', 'medium'],
      background: ['greyscale', 'white'],
    },
    hover: {
      borderColor: ['danger', 'medium'],
      color: ['danger', 'medium'],
      background: ['greyscale', 'light'],
    },
  },
};
